import * as React from 'react';
import { RouterState } from 'connected-react-router';
import { GlobalPrivateState } from 'src/api';
import { Switch, Route } from 'react-router';
import ProjectEdit from '../ProjectsEdit/ProjectsEdit';
import { connect } from 'react-redux';
import ProjectDelete from '../ProjectsDelete/ProjectsDelete';

export interface ProjectDetailProps {
  dispatch: any;
  location: RouterState['location'];
  project: GlobalPrivateState['project'];
  projectId: string;
}

export class ProjectDetailPartial extends React.Component<ProjectDetailProps> {
  public render() {
    const { projectId } = this.props;
    return (
      <div className="page-project-detail">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Switch>
                <Route
                  exact={true} 
                  path={`/profile/projects/${projectId}/edit`} 
                  component={ProjectEdit}
                />
                <Route
                  exact={true} 
                  path={`/profile/projects/${projectId}/delete`} 
                  component={ProjectDelete}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const ProjectDetail = connect((state: GlobalPrivateState) => ({
  location: state.router.location,
  project: state.project,
}))(ProjectDetailPartial);

export default ProjectDetail;